var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21275 9.01742C7.93506 9.01742 9.33241 7.5827 9.33241 5.81432C9.33241 4.04595 7.93506 2.61123 6.21275 2.61123C4.49044 2.61123 3.09309 4.04595 3.09309 5.81432C3.09309 7.5827 4.49044 9.01742 6.21275 9.01742ZM8.98578 9.72922H7.79208C7.31113 9.9561 6.77602 10.0851 6.21275 10.0851C5.64948 10.0851 5.11654 9.9561 4.63342 9.72922H3.43972C1.90805 9.72922 0.666687 11.0038 0.666687 12.5764V12.9323C0.666687 13.5218 1.13247 14 1.70657 14H10.7189C11.293 14 11.7588 13.5218 11.7588 12.9323V12.5764C11.7588 11.0038 10.5174 9.72922 8.98578 9.72922Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2473 5.19043L14.9448 5.16528C15.1531 5.1622 15.3245 4.99138 15.3277 4.78368L15.3333 4.40766C15.3364 4.20004 15.17 4.03423 14.9616 4.03723L13.2641 4.06238L13.2893 2.37047C13.2924 2.16285 13.126 1.99704 12.9176 2.00004L12.5404 2.00563C12.3321 2.00872 12.1607 2.17953 12.1575 2.38724L12.1323 4.07914L10.4347 4.10429C10.2264 4.10738 10.055 4.27819 10.0518 4.4859L10.0462 4.86191C10.0431 5.06953 10.2096 5.23543 10.4179 5.23234L12.1154 5.2072L12.0902 6.8991C12.0871 7.10672 12.2536 7.27262 12.4619 7.26953L12.8392 7.26394C13.0475 7.26086 13.2188 7.09004 13.222 6.88234L13.2473 5.19043Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersAdd);
export default __webpack_public_path__ + "static/media/users-add.f210b9e93d9e4fd09d50f7a3610af127.svg";
export { ForwardRef as ReactComponent };